import isEqual from "lodash/isEqual";
type NotifyFn = {
  info: (title: string, message: string) => void;
};

/**
 * Check if form data has changed compared to original data and notify if not
 * @param currentData - Current form data
 * @param originalData - Original server data
 * @param notify - Notification object with an info method
 * @returns true if changes exist, false otherwise
 */
export function checkFormChanges(
  currentData: Record<string, any>,
  originalData: Record<string, any>,
  notify: NotifyFn
): boolean {
  const allKeys = new Set([
    ...Object.keys(currentData),
    ...Object.keys(originalData),
  ]);

  const hasChanges = [...allKeys].some(
    key => !isEqual(currentData[key], originalData[key])
  );

  if (!hasChanges) {
    notify.info("No Changes", "No changes made");
    return false;
  }

  return true;
}
